import { Component, Input } from '@angular/core';
import { CardItemModel } from '../../model/card/card-item-model';

const HTML_TEMPLATE = `
<ion-item no-lines no-padding>
  <ion-thumbnail *ngIf="card.img" item-start>
    <img width="72px" height="72px" src="{{card.img}}">
  </ion-thumbnail>
  <h2 *ngIf="card.title">{{card.title}}</h2>
  <p *ngIf="card.subTitle">{{card.subTitle}}</p>
  <button ion-button clear item-end>
      <ion-icon name="ios-arrow-forward"></ion-icon>
  </button>
</ion-item>
<hr>
`;

const CSS_STYLE = `   
img {
    border-radius: 4px;
    object-fit: cover;
    margin-left: 16px;
}
h2 {
    font-size: 14px;
    font-weight: bold !important;
    color: #4a5c60;    
}
p {
    color: #4a5c60;
    opacity: 0.5;
}


`;

/*@Component({
    selector: 'card-item',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})*/
export class CardItemComponent {

  @Input('card') card: CardItemModel;

  constructor() {
  }

  ngAfterViewInit() {
  }

}
